import { render, staticRenderFns } from "./Resident.vue?vue&type=template&id=b2a33e5a&scoped=true"
import script from "./Resident.vue?vue&type=script&lang=js"
export * from "./Resident.vue?vue&type=script&lang=js"
import style0 from "./Resident.vue?vue&type=style&index=0&id=b2a33e5a&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a33e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2a33e5a')) {
      api.createRecord('b2a33e5a', component.options)
    } else {
      api.reload('b2a33e5a', component.options)
    }
    module.hot.accept("./Resident.vue?vue&type=template&id=b2a33e5a&scoped=true", function () {
      api.rerender('b2a33e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolManage/resident/Resident.vue"
export default component.exports